import { Fragment, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getListPayments } from "actions/paymentActions";
import { formatterCreateAt, FormatterStatus } from "components/Function";
import { ReactTable } from "components/Table";
import { ModalAddPayment, ModalEditPayment } from "./modal";

function Listpayments(props) {
    const [isOpenModalAddPayment, setIsOpenModalAddPayment] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [paymentSelect, setPaymentSelect] = useState(null);

    const { t } = useTranslation();
    var { listpayments, totalsize } = props.payment;
    var { getListPayments, formatterCreateAt, FormatterStatus } = props;

    useEffect(() => {
        getListPayments(page, sizePerPage, searchText);
    }, [getListPayments, page, sizePerPage, searchText]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    const onClickOpenModalAddPayment = () => {
        setIsOpenModalAddPayment(!isOpenModalAddPayment);
    };

    const onClickDeletePayment = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText
            }
        }
        // deletePayment(row);
    };

    const columns = [{
        dataField: '_id',
        text: "",
        sort: true,
        formatter: (cell, row, rowIndex) => rowIndex + 1
    }, {
        dataField: 'name',
        text: t("Name"),
        sort: true,
    }, {
        dataField: 'merchant_id',
        text: t("Merchant ID"),
        sort: true,
    }, {
        dataField: 'total_receive',
        text: t("Total Receive"),
        sort: true,
    }, {
        dataField: 'status',
        text: t("Status"),
        sort: true,
        formatter: (cell, row) => <FormatterStatus status={cell} />,
    }, {
        dataField: 'created_at',
        text: t("Created At"),
        sort: true,
        formatter: (cell, row) => formatterCreateAt(cell)
    }, {
        dataField: 'updated_at',
        text: t("Update At"),
        sort: true,
        formatter: (cell, row) => formatterCreateAt(cell)
    }, {
        dataField: '-',
        text: t("Actions"),
        formatter: (cell, row, rowIndex, formatExtraData) =>
            <Fragment>
                <button onClick={() => { setPaymentSelect(row) }} className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Edit")}>
                    <i className="ki-outline ki-notepad-edit fs-2"></i>
                </button>
                <button onClick={() => { onClickDeletePayment(row, formatExtraData) }} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" data-tooltip-id="my-tooltip" data-tooltip-content={t("Delete")}>
                    <i className="ki-outline ki-trash fs-2"></i>
                </button>
            </Fragment>

    }];

    const groupButton = () => {
        return (
            <div className="mb-5">
                <button onClick={() => { onClickOpenModalAddPayment() }} type="button" className="btn btn-primary btn-sm me-1">
                    <i className="ki-outline ki-plus fs-2"></i> {t("Add Payment")}
                </button>
            </div>
        );
    }

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page||1);
            setSizePerPage(sizePerPage);
        }
    }

    const sizePerPageList = [
        {
            text: '10', value: 10
        },
        {
            text: '50', value: 50
        },
        {
            text: '100', value: 100
        },
        {
            text: '150', value: 150
        },
        {
            text: '200', value: 200
        },
        {
            text: 'All', value: totalsize||50
        }
    ];

    return (
        <Fragment>
            <div className="card mb-5 mb-xl-10">
                <div className="card-body p-9">
                    <div className="al-variants-table">
                        <ReactTable columns={columns} data={listpayments} groupButton={groupButton} handleTableChange={handleTableChange} page={page} sizePerPage={sizePerPage} totalSize={totalSize} alClassName="table-layout-inherit" sizePerPageList={sizePerPageList} />
                    </div>
                    {isOpenModalAddPayment ? <ModalAddPayment openModal={onClickOpenModalAddPayment} isOpenModalAddPayment={isOpenModalAddPayment} /> : ''}
                    <ModalEditPayment
                        data={paymentSelect}
                        onClose={() => setPaymentSelect(null)}
                        onSubmit={() => {
                            getListPayments(page, sizePerPage, searchText);
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
}

Listpayments.propTypes = {
    getListPayments: PropTypes.func.isRequired,
    formatterCreateAt: PropTypes.func.isRequired,
    FormatterStatus: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    payment: state.payment
});
const mapDispatchToProps = {
    getListPayments,
    formatterCreateAt,
    FormatterStatus,
}

export default connect(mapStateToProps, mapDispatchToProps)(Listpayments);